export const ADMIN_BASE_NAME = process.env.REACT_APP_ADMIN_BASE_NAME || '';
export const ADMIN_BASE_URL = process.env.REACT_APP_ADMIN_BASE_URL || '';
export const AUTH_CLIENTID = process.env.REACT_APP_AUTH_CLIENTID || '';
export const AUTH_APPWEBDOMAIN = process.env.REACT_APP_AUTH_APPWEBDOMAIN || '';
export const AUTH_REDIRECTURISIGNIN = process.env.REACT_APP_AUTH_REDIRECTURISIGNIN_ADMIN || '';
export const AUTH_REDIRECTURISIGNOUT = process.env.REACT_APP_AUTH_REDIRECTURISIGNOUT_ADMIN || '';
export const PROJECTS_URL = process.env.REACT_APP_PROJECTS_URL || '';
export const SERVICES_FILE_NAME = process.env.REACT_APP_SERVICES_FILE_NAME || '';